<template>
  <div>
    <!-- <div style="height: 20%; overflow: auto;">
      <h3>Simple map</h3>
      <p>First marker is placed at {{ withPopup.lat }}, {{ withPopup.lng }}</p>
      <p>Center is at {{ currentCenter }} and the zoom is: {{ currentZoom }}</p>
      <button @click="showLongText">Toggle long popup</button>
      <button @click="showMap = !showMap">Toggle map</button>
    </div> -->
    <p class="mb-2" style="font-size: 1rem;" tabindex="0">
      {{ $t("mapDescriptioin") }}
    </p>
    <!-- <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 94%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker
        v-for="marker in markers"
        :key="marker.id"
        :visible="marker.visible"
        :draggable="marker.draggable"
        :lat-lng.sync="marker.position"
        :icon="marker.icon"
        @click="innerClick"
      >
        <l-popup :content="marker.tooltip" />
      </l-marker>
    </l-map> -->

    <v-map :zoom="zoom" :center="center" style="height: 94%">
      <v-icondefault></v-icondefault>
      <v-tilelayer :url="url"></v-tilelayer>
      <v-marker-cluster
        :options="clusterOptions"
        @clusterclick="click()"
        @ready="ready"
      >
        <v-marker
          v-for="l in markers"
          :key="l.id"
          :visible="l.visible"
          :draggable="l.draggable"
          :lat-lng.sync="l.latlng"
          :icon="l.icon"
          @click="innerClick"
        >
          <v-popup :content="l.tooltip"></v-popup>
        </v-marker>
      </v-marker-cluster>
    </v-map>
  </div>
</template>

<script>
import * as Vue2Leaflet from "vue2-leaflet";
import { latLng, Icon, icon } from "leaflet";
// import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import Vue2LeafletMarkercluster from "./Vue2LeafletMarkercluster";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";

// import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";

import axios from "axios";

function rand(n) {
  let max = n + 0.1;
  let min = n - 0.1;
  return Math.random() * (max - min) + min;
}

export default {
  name: "Example",
  components: {
    // LMap,
    // LTileLayer,
    // LMarker,
    // LPopup,
    "v-map": Vue2Leaflet.LMap,
    "v-tilelayer": Vue2Leaflet.LTileLayer,
    "v-icondefault": Vue2Leaflet.LIconDefault,
    "v-marker": Vue2Leaflet.LMarker,
    "v-popup": Vue2Leaflet.LPopup,
    "v-marker-cluster": Vue2LeafletMarkercluster
    // LTooltip
  },
  data() {
    let locations = [];
    for (let i = 0; i < 100; i++) {
      locations.push({
        id: i,
        latlng: latLng(rand(-34.9205), rand(-57.953646)),
        text: "Hola " + i
      });
    }
    let customicon = icon(
      Object.assign({}, Icon.Default.prototype.options, { iconUrl, shadowUrl })
    );
    return {
      zoom: 7,
      center: latLng(53.91116327625304, 27.52947006491013),
      // center: latLng(47.41322, -1.219482),
      url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: 11,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true,
      markers: [],
      locations,
      icon: customicon,
      clusterOptions: {},
      initialLocation: latLng(-34.9205, -57.953646)
    };
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.clusterOptions = { disableClusteringAtZoom: 11 };
      });
    }, 5000);
  },
  methods: {
    click: e => console.log("clusterclick", e),
    ready: e => console.log("ready", e),
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      // alert("Click!");
    },
    csvJSON(csv) {
      const lines = csv.split("\n");
      const result = [];
      const headers = lines[0].split('","');
      headers.forEach((item, index) => {
        return (headers[index] = item.replace(/"/g, ""));
      });

      for (let i = 1; i < lines.length; i++) {
        if (!lines[i]) continue;
        const obj = {};
        const currentline = lines[i].split('","');
        currentline.forEach((item, index) => {
          return (currentline[index] = item.replace(/"/g, ""));
        });

        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }
        result.push(obj);
      }
      return result;
    },
    prepareMarkers() {
      const src = JSON.parse(localStorage.getItem("points"));
      var markers = [];
      src.forEach(item => {
        if (item.lat && item.lon) {
          const marker = {
            id: item.poi,
            position: {
              lat: item.lat.replace(",", "."),
              lng: item.lon.replace(",", ".")
            },
            tooltip: this.getName(item),
            draggable: false,
            visible: true
          };
          markers.push(marker);
        }
      });
      this.markers = markers;
    },
    prepareMarkersNew() {
      const src = JSON.parse(localStorage.getItem("pointsJson"));
      var markers = [];
      src.forEach(item => {
        if (item.lat && item.lon) {
          const marker = {
            id: item.id,
            position: {
              lat: item.lat.replace(",", "."),
              lng: item.lon.replace(",", ".")
            },
            latlng: {
              lat: item.lat.replace(",", "."),
              lng: item.lon.replace(",", ".")
            },
            tooltip: item.nameRu,
            draggable: false,
            visible: true,
            type: item.type,
            icon: icon({
              iconUrl: this.getIcon(item.type),
              iconSize: [32, 32],
              className: item.type
            })
          };
          markers.push(marker);
        }
      });
      this.markers = markers;
    },
    getIcon(type) {
      switch (type) {
        case "point":
          return require("@/assets/info_outline.svg");
        case "queue":
          return require("@/assets/people_alt.svg");
        case "stop":
          return require("@/assets/directions_bus.svg");
        case "traffic_light":
          return require("@/assets/traffic.svg");
        default:
          return "";
      }
    },
    getName(item) {
      return item.ru;
    }
  },
  created() {
    this.loading = true;
    // axios
    //   .get("https://admin.buzzpoint.org/buzzpoint-service/public/details")
    //   .then(response => {
    //     const points = this.csvJSON(response.data);
    //     localStorage.setItem("points", JSON.stringify(points));
    //     // this.prepareMarkers();
    //   });
    axios
      .get("https://admin.buzzpoint.org/buzzpoint-service/public/details/map")
      .then(response => {
        const pointsJson = response.data;
        localStorage.setItem("pointsJson", JSON.stringify(pointsJson));
        this.prepareMarkersNew();
      });
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.prepareMarkers();
      }
    }
  }
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
